var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 4.895C21 3.848 20.194 3 19.2 3H4.8C3.806 3 3 3.848 3 4.895v10.61c0 1.047.806 1.895 1.8 1.895h12.6L21 21zm-3.24 11.558 2.34 2.34V4.895c0-.523-.403-.948-.9-.948H4.8c-.497 0-.9.425-.9.948v10.61c0 .524.403.948.9.948z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.883 8.744a.477.477 0 0 0-.03-.657.44.44 0 0 0-.636.03l-3.774 4.291-1.872-1.975a.44.44 0 0 0-.636-.007.477.477 0 0 0-.006.658l2.538 2.68z"
  })));
};
export default SvgSupport;